import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { WorkshopCardboardStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('workshop-cardboard', reducer),
        EffectsModule.forFeature([WorkshopCardboardStoreEffects]),
    ],
    providers: [],
})
export class WorkshopCardboardStoreModule { }
